// import logo from './logo.svg';
// import './App.css';

import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Highlights from './components/Highlights';
import LocationMap from './components/LocationMap';
import Amenities from './components/Amenities';
import LeisureAmenities from './components/LeisureAmenities';
import Gallery from './components/Gallery';
import WhyInvest from './components/WhyInvest';
import LonavalaInvestment from './components/LonavalaInvestment';
import WhatStandOut from './components/WhatStandOut';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import ContactForm from './components/ContactForm';
import Faqs from './components/Faqs';
import Footer from './components/Footer';
import ScrollIndicator from './components/ScrollIndicator';

import Gallery2 from './components/Gallery2';

import Loader from './components/Loader';

function Home() {
  return (
    <main>
      <Hero />
      <Highlights />
       <Gallery2 />
      <LocationMap />
      <Amenities />
      <LeisureAmenities />
     
      <WhyInvest />
      <LonavalaInvestment />
      <WhatStandOut />
      <Testimonials />
      <Pricing />
      <Faqs />
      <ContactForm />
    </main>
  );
}

export default function App() {
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    // simulate initial preloader (replace with real asset load logic)
    const t = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(t);
  }, []);


  return (
    <div className="app-root">
      <ScrollIndicator />
      {loading && <Loader />}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        {/* extend routes for brochure, contact, register etc. */}
      </Routes>
      <Footer />
    </div>
  );
}